import { render, staticRenderFns } from "./EstudiosPdf.vue?vue&type=template&id=6a48c593"
import script from "./EstudiosPdf.vue?vue&type=script&lang=js"
export * from "./EstudiosPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports